/*
  Northern Black: small fixes on top of the I Agree app (Shop Sappers).
  The terms requirement is unchanged: checkout still needs the box ticked or "I Agree" clicked.

  1. After a shopper clicks "I Agree" in the app's pop-up, carry on to the checkout button
     they clicked first, so they don't have to click Checkout twice.
  2. Point the "I agree to the terms and conditions" link at the terms page instead of "#".
     A normal click still opens the app's pop-up; long-press, middle-click or no-JS now reach the real page.

  Loaded from layout/theme.liquid. Remove the script tag there to switch both fixes off.
*/
(function () {
  'use strict';

  var CHECKOUT_SELECTOR = "button[name='checkout'], a[href='/checkout'], a[href*='/cart/c/']";
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var termsUrl = root + 'policies/terms-of-service';
  var pendingCheckout = null;

  function hasAgreed() {
    var checkbox = document.querySelector('.wptc-terms');
    return !!(checkbox && checkbox.checked);
  }

  function isVisible(el) {
    return !!(el && el.offsetParent !== null);
  }

  // Remember which checkout control was clicked while the box was unticked.
  document.addEventListener('click', function (e) {
    if (!e.isTrusted || !e.target.closest) return;
    var checkout = e.target.closest(CHECKOUT_SELECTOR);
    if (!checkout) return;
    pendingCheckout = hasAgreed() ? null : checkout;
  }, true);

  // When "I Agree" is clicked in the app's pop-up, wait for the app to tick the box,
  // save it to the cart and close the pop-up, then continue to that checkout control.
  window.addEventListener('click', function (e) {
    if (!pendingCheckout || !e.target.closest) return;
    var agreeButton = e.target.closest('.tingle-btn--primary');
    if (!agreeButton || !agreeButton.closest('.iagree-class-1')) return;

    var checkout = pendingCheckout;
    pendingCheckout = null;
    var attempts = 0;

    (function continueWhenReady() {
      var popupOpen = document.querySelector('.iagree-class-1.tingle-modal--visible');
      if (hasAgreed() && !popupOpen) {
        if (!document.contains(checkout) || !isVisible(checkout)) {
          checkout = Array.prototype.filter.call(document.querySelectorAll(CHECKOUT_SELECTOR), isVisible)[0];
        }
        if (checkout) checkout.click();
        return;
      }
      attempts += 1;
      if (attempts < 50) setTimeout(continueWhenReady, 100);
    })();
  }, true);

  function fixTermsLinks() {
    var links = document.querySelectorAll('a.showTerms');
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute('href') === '#') links[i].setAttribute('href', termsUrl);
    }
  }

  var scheduled = false;
  function scheduleFix() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      fixTermsLinks();
    });
  }

  function start() {
    fixTermsLinks();
    new MutationObserver(scheduleFix).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
